export const DEFAULT_CONTENT = {
  hero: {
    overline: "Jamna Industries — HDPE • Sprinkler • Drip",
    line1: "Engineering the Future",
    line2a: "of Indian",
    line2b: "Agriculture.",
    sub: "Precision HDPE pipes and micro-irrigation systems, built in India for every acre.",
    tagline: "Har Boond Mein Vikas.",
    image:
      "https://images.unsplash.com/photo-1777120706328-965a3568d1cb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwzfHx3YXRlciUyMHNwcmlua2xlciUyMGlycmlnYXRpb24lMjBmYXJtfGVufDB8fHx8MTc4NzkzOTcyM3ww&ixlib=rb-4.1.0&q=85&w=2000",
  },
  marquee: ["HDPE Pipes", "Mini Sprinklers", "Drip Irrigation", "PVC Fittings", "Industrial Valves", "Har Boond Mein Vikas"],
  manifesto: {
    overline: "Our Legacy — Hamari Virasat",
    headingA: "Mitti se judi,",
    headingAccent: "takneek",
    headingB: "se mazboot.",
    image:
      "https://images.unsplash.com/photo-1528693404014-b13ebe6e723e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHw0fHxhZ3JpY3VsdHVyZSUyMGZpZWxkcyUyMGluZGlhJTIwZmFybWVyfGVufDB8fHx8MTc4NzkzOTcyM3ww&ixlib=rb-4.1.0&q=85&w=1200",
    caption: "Fields of Rajasthan — mini sprinkler trial, rabi season",
    chapters: [
      { num: "01", title: "Kisanon Se Shuru", text: "Jamna Industries ki shuruaat ek hi soch se hui — Bharat ke kisan ko duniya ke sabse bharosemand irrigation tools dena, sahi daam par." },
      { num: "02", title: "Precision Engineering", text: "Every HDPE coil and sprinkler head is manufactured to ISI-grade tolerances and pressure-tested for the toughest Indian terrains." },
      { num: "03", title: "Har Boond Mein Vikas", "text": "Our drip and mini sprinkler systems save up to 60% water — more yield per drop, more income per acre, season after season." },
    ],
  },
  products: [
      {
            "id": "hdpe-pipes",
            "num": "01",
            "name": "HDPE Pipes",
            "hindi": "एचडीपीई पाइप",
            "desc": "High-density polyethylene piping for water supply, sprinkler mains and drip networks. Flexible, UV-stabilised and leak-proof — available in coils and straight lengths for every farm size.",
            "features": [
                  "IS 4984 certified — PE-63 / PE-80 / PE-100 grades",
                  "UV-stabilised for harsh Indian summers",
                  "Leak-proof butt-fusion & electrofusion joints",
                  "50+ years service life, zero corrosion"
            ],
            "range": [
                  "HDPE Coil Pipes",
                  "HDPE Straight Pipes",
                  "Sprinkler Main Pipes",
                  "MDPE Pipes"
            ],
            "specs": [
                  "20–110 mm",
                  "PN 2.5–16",
                  "IS 4984"
            ],
            "img": "https://compassionate-mclaren-9.preview.emergentagent.com/api/files/jamna-industries/uploads/f4d16ba2-18ae-4050-afef-fd749da9bfdb.jpg",
            "alt": "Coils of black HDPE pipe",
            "items": [
                  "HDPE Coil Pipe — 20/25/32/40/50/63/75/90/110 mm",
                  "HDPE Straight Pipe (6 m length)",
                  "Sprinkler Main Pipe",
                  "MDPE Pipe",
                  "HDPE Bend / Elbow",
                  "HDPE Tee",
                  "HDPE End Cap",
                  "HDPE Coupler",
                  "HDPE Reducer",
                  "Electrofusion Fittings"
            ]
      },
      {
            "id": "pvc-pipes",
            "num": "02",
            "name": "PVC Pipes",
            "hindi": "पीवीसी पाइप",
            "desc": "UPVC/PVC pressure pipes for water supply, borewell lines aur plumbing — smooth bore, corrosion-free, easy solvent joints.",
            "features": [
                  "IS 4985 certified uPVC material",
                  "Smooth bore — low friction loss",
                  "Corrosion & chemical resistant",
                  "Solvent joint — quick installation"
            ],
            "range": [
                  "PVC Pressure Pipes",
                  "PVC Casing Pipes",
                  "PVC Suction Hose",
                  "Plumbing Pipes"
            ],
            "specs": [
                  "20–160 mm",
                  "PN 4–10",
                  "IS 4985"
            ],
            "img": "https://compassionate-mclaren-9.preview.emergentagent.com/api/files/jamna-industries/uploads/44ee0991-2daa-45a6-be43-ea73bc50da70.jpg",
            "alt": "PVC pipes stacked in yard",
            "items": [
                  "PVC Pressure Pipe — 20/25/32/40/50/63/75/90/110/160 mm",
                  "PVC Casing Pipe (Borewell)",
                  "PVC Suction Hose Pipe",
                  "Plumbing Pipe",
                  "PVC Pipe Solvent Cement"
            ]
      },
      {
            "id": "sprinkler-systems",
            "num": "03",
            "name": "Sprinkler Irrigation Systems",
            "hindi": "स्प्रिंकलर सिंचाई",
            "desc": "Complete sprinkler irrigation sets with HDPE mains, risers aur nozzles — wheat, gram aur fodder crops ke liye uniform paani distribution.",
            "features": [
                  "Uniform coverage bade fields mein",
                  "40% tak paani ki bachat vs flood",
                  "Quick-coupling HDPE pipelines",
                  "Low maintenance, long life"
            ],
            "range": [
                  "Sprinkler Sets",
                  "HDPE Main Lines",
                  "Riser Pipes",
                  "Sprinkler Nozzles"
            ],
            "specs": [
                  "1.5–4.0 kg/cm²",
                  "10–14 m radius",
                  "IS 14151"
            ],
            "img": "https://compassionate-mclaren-9.preview.emergentagent.com/api/files/jamna-industries/uploads/e2d2a001-83d1-4786-920d-3892e857d3fa.jpg",
            "alt": "Sprinklers spraying water over a field",
            "items": [
                  "Sprinkler Nozzle (Brass / Plastic)",
                  "Sprinkler Riser Pipe",
                  "HDPE Main Line Pipe",
                  "Quick Coupling Bend",
                  "Quick Coupling Tee",
                  "Quick Coupling End Plug",
                  "Pump Connector Nipple",
                  "Sprinkler Stand",
                  "Service Saddle",
                  "Sprinkler Key & Spanner"
            ]
      },
      {
            "id": "mini-sprinklers",
            "num": "04",
            "name": "Mini Sprinkler Systems",
            "hindi": "मिनी स्प्रिंकलर सिस्टम",
            "desc": "Uniform rain-like micro-irrigation for vegetables, groundnut, onion and cash crops. Complete kits with riser pipes, nozzles and quick-coupling HDPE mains — ready to install on any field.",
            "features": [
                  "Gentle rain-like coverage, no soil compaction",
                  "Saves up to 50% water vs flood irrigation",
                  "Quick-coupling joints — shift lines in minutes",
                  "Ideal for close-spaced & delicate crops"
            ],
            "range": [
                  "Mini Sprinkler Kit",
                  "Micro Sprinklers",
                  "Rain Guns",
                  "Riser Pipes & Nozzles"
            ],
            "specs": [
                  "1.5–3.0 kg/cm²",
                  "8–12 m radius",
                  "Quick-coupling"
            ],
            "img": "https://compassionate-mclaren-9.preview.emergentagent.com/api/files/jamna-industries/uploads/cb4e19c9-0d59-4cd7-8078-246dfa639ff3.jpg",
            "alt": "Sprinklers spraying water over a corn field",
            "items": [
                  "Mini Sprinkler Head",
                  "Mini Sprinkler Nozzle Set",
                  "Riser Pipe 1/2 inch",
                  "Connecting Tube",
                  "Stake / Stand",
                  "Mini Sprinkler Connector",
                  "Butterfly Sprinkler",
                  "Fogger / Mister",
                  "G-Type Mini Sprinkler",
                  "Mini Sprinkler Assembly (Complete)"
            ]
      },
      {
            "id": "micro-sprinklers",
            "num": "05",
            "name": "Micro Sprinkler Systems",
            "hindi": "माइक्रो स्प्रिंकलर",
            "desc": "Orchards aur nurseries ke liye low-flow micro sprinklers — root zone ke aas-paas gentle mist, har paudhe tak barabar paani.",
            "features": [
                  "Low-flow mist for orchards & nurseries",
                  "Frost protection bhi possible",
                  "Anti-insect nozzles",
                  "10–70 LPH range"
            ],
            "range": [
                  "Micro Sprinklers",
                  "Micro Jets",
                  "Hanging Assemblies",
                  "Stakes & Tubes"
            ],
            "specs": [
                  "10–70 LPH",
                  "1.0–2.5 kg/cm²",
                  "Anti-clog"
            ],
            "img": "https://compassionate-mclaren-9.preview.emergentagent.com/api/files/jamna-industries/uploads/e285b743-d744-43a6-85ee-c0836d48ab61.png",
            "alt": "Micro irrigation watering young plants",
            "items": [
                  "Micro Sprinkler (10–70 LPH)",
                  "Micro Jet",
                  "Hanging Assembly",
                  "Micro Tube",
                  "Micro Stake",
                  "Anti-Drain Valve",
                  "Micro Sprinkler Adapter",
                  "4/7 mm Fittings"
            ]
      },
      {
            "id": "portable-sprinklers",
            "num": "06",
            "name": "Portable Sprinkler Systems",
            "hindi": "पोर्टेबल स्प्रिंकलर",
            "desc": "Ek field se doosre field mein minutes mein shift hone wala portable sprinkler set — quick-coupling pipes aur tripod stands ke saath.",
            "features": [
                  "Minutes mein shift — ek set, kai fields",
                  "Quick-coupling aluminium/HDPE pipes",
                  "Tripod & riser options",
                  "Chhote kisan ke liye sabse economical"
            ],
            "range": [
                  "Portable Sprinkler Sets",
                  "Coupling Pipes",
                  "Tripod Stands",
                  "Pump Connectors"
            ],
            "specs": [
                  "Shift in minutes",
                  "8–12 m radius",
                  "Lightweight"
            ],
            "img": "https://images.unsplash.com/photo-1758414089320-dac72d347fca?auto=format&fit=crop&w=1200&q=80",
            "alt": "Portable irrigation line working in the field",
            "items": [
                  "Portable Sprinkler Set (Complete)",
                  "Aluminium Coupling Pipe",
                  "HDPE Coupling Pipe",
                  "Tripod Stand",
                  "Riser Pipe",
                  "Foot Batten",
                  "Pump Suction Connector",
                  "Quick Coupling Gasket"
            ]
      },
      {
            "id": "drip-systems",
            "num": "07",
            "name": "Drip Irrigation Systems",
            "hindi": "ड्रिप सिंचाई सिस्टम",
            "desc": "Drop-by-drop precision with inline laterals, online drippers and complete drip kits up to 5 acres. Anti-clog emitters deliver water straight to the root zone — maximum yield, minimum waste.",
            "features": [
                  "Saves up to 60% water, doubles fertiliser efficiency",
                  "Anti-clog pressure-compensating emitters",
                  "Complete kits: filters, venturi, laterals, drippers",
                  "Subsidy-ready designs as per PMKSY norms"
            ],
            "range": [
                  "Inline Drip Laterals",
                  "Online Drippers",
                  "Drip Kits (1–5 acre)",
                  "Screen & Disc Filters",
                  "Venturi Injectors"
            ],
            "specs": [
                  "16 mm laterals",
                  "2/4/8 LPH",
                  "Anti-clog"
            ],
            "img": "https://compassionate-mclaren-9.preview.emergentagent.com/api/files/jamna-industries/uploads/c2fade69-569b-424b-85dc-5459eb5b335e.jpg",
            "alt": "Drip irrigation lines watering young plants in soil",
            "items": [
                  "Inline Drip Lateral 16 mm",
                  "Online Dripper — 2/4/8 LPH",
                  "Plain Drip Lateral",
                  "Screen Filter",
                  "Disc Filter",
                  "Venturi Injector",
                  "Start Connector",
                  "Take-off / Grommet",
                  "Lateral End Cap",
                  "Lateral Valve",
                  "Flush Valve",
                  "Hole Punch",
                  "Fertilizer Tank"
            ]
      },
      {
            "id": "rain-guns",
            "num": "08",
            "name": "Rain Guns",
            "hindi": "रेन गन",
            "desc": "Sugarcane, fodder aur bade fields ke liye high-pressure rain guns — 20–40 meter tak throw, kam labour mein zyada coverage.",
            "features": [
                  "20–40 m throw radius",
                  "Adjustable arc & full circle",
                  "Brass/impact body options",
                  "Sugarcane & fodder ke liye best"
            ],
            "range": [
                  "Rain Guns",
                  "Impact Guns",
                  "Stands & Trolleys",
                  "High-pressure Hoses"
            ],
            "specs": [
                  "20–40 m throw",
                  "2.0–5.0 kg/cm²",
                  "Adjustable arc"
            ],
            "img": "https://compassionate-mclaren-9.preview.emergentagent.com/api/files/jamna-industries/uploads/f4d16ba2-18ae-4050-afef-fd749da9bfdb.jpg",
            "alt": "Rain gun spraying over a green field",
            "items": [
                  "Rain Gun (Brass / Impact)",
                  "Rain Gun Stand",
                  "Trolley Mount",
                  "High-Pressure Hose",
                  "Hose Connector",
                  "Heavy Duty Tripod",
                  "Rain Gun Nozzle Set"
            ]
      },
      {
            "id": "ldpe-laterals",
            "num": "09",
            "name": "LDPE Laterals & Tubes",
            "hindi": "एलडीपीई लेटरल",
            "desc": "LDPE laterals aur micro tubes for drip and mini sprinkler lines — flexible, UV-stabilised, easy punching for emitters.",
            "features": [
                  "UV-stabilised LDPE material",
                  "Flexible & kink-resistant",
                  "Easy emitter punching",
                  "Coil packing 100–500 m"
            ],
            "range": [
                  "LDPE Laterals 12/16/20 mm",
                  "Micro Tubes 4/7 mm",
                  "Lateral Coils",
                  "Feeder Pipes"
            ],
            "specs": [
                  "12–20 mm",
                  "PN 2.5–4",
                  "UV-stabilised"
            ],
            "img": "https://compassionate-mclaren-9.preview.emergentagent.com/api/files/jamna-industries/uploads/f4d16ba2-18ae-4050-afef-fd749da9bfdb.jpg",
            "alt": "LDPE lateral pipes on field",
            "items": [
                  "LDPE Lateral 12 mm",
                  "LDPE Lateral 16 mm",
                  "LDPE Lateral 20 mm",
                  "Micro Tube 4/7 mm",
                  "Lateral Coil 100 m",
                  "Lateral Coil 500 m"
            ]
      },
      {
            "id": "filters",
            "num": "10",
            "name": "Screen & Disc Filters",
            "hindi": "स्क्रीन और डिस्क फिल्टर",
            "desc": "Screen aur disc filters for drip/sprinkler systems — sand aur particles rok kar emitters ko clog hone se bachate hain.",
            "features": [
                  "120-mesh fine filtration",
                  "Easy-clean screen/disc element",
                  "PP / metal body options",
                  "2–3 inch inlet sizes"
            ],
            "range": [
                  "Screen Filters",
                  "Disc Filters",
                  "Sand Media Filters",
                  "Y-Type Filters"
            ],
            "specs": [
                  "120 mesh",
                  "2–3 inch",
                  "10 kg/cm²"
            ],
            "img": "https://compassionate-mclaren-9.preview.emergentagent.com/api/files/jamna-industries/uploads/7879edf9-625d-475d-8b74-5c1b6ef899ad.jpg",
            "alt": "Irrigation filter unit",
            "items": [
                  "Screen Filter 2 inch",
                  "Screen Filter 3 inch",
                  "Disc Filter 2 inch",
                  "Disc Filter 3 inch",
                  "Sand Media Filter",
                  "Y-Type Filter",
                  "Filter Element (Spare)"
            ]
      },
      {
            "id": "venturi",
            "num": "11",
            "name": "Venturi & Fertilizer Injectors",
            "hindi": "वेंचुरी और फर्टिलाइज़र",
            "desc": "Venturi injectors aur fertilizer tanks — drip line mein khad/fertilizer mix karne ka simple aur reliable tareeka.",
            "features": [
                  "No moving parts — zero maintenance",
                  "Uniform fertilizer mixing",
                  "Fits 16–50 mm lines",
                  "Complete kit with tubes"
            ],
            "range": [
                  "Venturi Injectors",
                  "Fertilizer Tanks",
                  "Suction Tubes & Kits",
                  "Bypass Assemblies"
            ],
            "specs": [
                  "16–50 mm",
                  "PP body",
                  "Tool-free"
            ],
            "img": "https://compassionate-mclaren-9.preview.emergentagent.com/api/files/jamna-industries/uploads/f4d16ba2-18ae-4050-afef-fd749da9bfdb.jpg",
            "alt": "Venturi injector equipment",
            "items": [
                  "Venturi Injector 3/4 inch",
                  "Venturi Injector 1 inch",
                  "Venturi Injector 2 inch",
                  "Fertilizer Tank 60L",
                  "Fertilizer Tank 90L",
                  "Suction Tube Kit",
                  "Bypass Assembly"
            ]
      },
      {
            "id": "fittings-valves",
            "num": "12",
            "name": "Fittings & Accessories",
            "hindi": "फिटिंग और एक्सेसरीज",
            "desc": "PVC fittings, HDPE/PP compression fittings, valves aur saare irrigation accessories — ek hi jagah poori range, leak-proof ISI-grade quality ke saath.",
            "features": [
                  "PVC / HDPE / PP — sab materials",
                  "Tool-free compression joints",
                  "Full range 20–110 mm",
                  "Leak-proof seals, long life"
            ],
            "range": [
                  "PVC Fittings",
                  "HDPE / PP Compression Fittings",
                  "Valves",
                  "Clamps & Saddles",
                  "Accessories"
            ],
            "specs": [
                  "PP / HDPE",
                  "20–110 mm",
                  "Leak-proof"
            ],
            "img": "https://compassionate-mclaren-9.preview.emergentagent.com/api/files/jamna-industries/uploads/f4d16ba2-18ae-4050-afef-fd749da9bfdb.jpg",
            "alt": "Industrial valves and machinery",
            "items": [
                  "PVC Elbow",
                  "PVC Tee",
                  "PVC Coupler",
                  "PVC Reducer",
                  "PVC Bush",
                  "PVC End Cap",
                  "PVC MTA / FTA",
                  "PVC Union",
                  "PVC Ball Valve",
                  "Tank Nipple",
                  "PP Compression Coupler",
                  "PP Compression Elbow",
                  "PP Compression Tee",
                  "HDPE Compression End Cap",
                  "Service Saddle",
                  "Saddle Clamp",
                  "PP Ball Valve",
                  "Foot Valve",
                  "Air Release Valve",
                  "Nipple / Hose Connector",
                  "Hose Clamp",
                  "Teflon Tape",
                  "GI Clamp",
                  "Sprinkler Key & Spanner",
                  "Riser Socket"
            ]
      },
      {
            "id": "pvc-fittings",
            "num": "13",
            "name": "PVC Fittings",
            "hindi": "पीवीसी फिटिंग",
            "desc": "Elbow, Tee, Coupler, Reducer, Bush, End Cap, MTA/FTA — full range 20–110 mm, leak-proof joints ke saath.",
            "features": [
                  "Solvent-weld leak-proof joints",
                  "Full range 20–110 mm",
                  "ISI-grade PVC material",
                  "Smooth inner finish"
            ],
            "range": [
                  "Elbow",
                  "Tee",
                  "Coupler",
                  "Reducer",
                  "Bush",
                  "End Cap",
                  "MTA/FTA",
                  "Union"
            ],
            "specs": [
                  "20–110 mm",
                  "PN 10",
                  "IS 7834"
            ],
            "img": "https://compassionate-mclaren-9.preview.emergentagent.com/api/files/jamna-industries/uploads/44ee0991-2daa-45a6-be43-ea73bc50da70.jpg",
            "alt": "PVC pipe fittings",
            "items": [
                  "PVC Elbow",
                  "PVC Tee",
                  "PVC Coupler",
                  "PVC Reducer",
                  "PVC Bush",
                  "PVC End Cap",
                  "PVC MTA / FTA",
                  "PVC Union",
                  "Tank Nipple"
            ]
      },
      {
            "id": "pp-compression-fittings",
            "num": "14",
            "name": "PP Compression Fittings",
            "hindi": "पीपी कम्प्रेशन फिटिंग",
            "desc": "Coupler, Elbow, Tee, End Cap — tool-free fitting, HDPE pipes ke liye perfect grip aur leak-proof seal.",
            "features": [
                  "Tool-free compression fit",
                  "Virgin PP body",
                  "Leak-proof O-ring seal",
                  "HDPE pipes ke liye perfect grip"
            ],
            "range": [
                  "Coupler",
                  "Elbow",
                  "Tee",
                  "End Cap",
                  "MTA/FTA"
            ],
            "specs": [
                  "20–110 mm",
                  "PN 16",
                  "Virgin PP"
            ],
            "img": "https://compassionate-mclaren-9.preview.emergentagent.com/api/files/jamna-industries/uploads/62ebd3a7-f2a1-4867-978f-eef8fbacf9d6.jpg",
            "alt": "PP compression fittings with pipes",
            "items": [
                  "PP Compression Coupler",
                  "PP Compression Elbow",
                  "PP Compression Tee",
                  "PP Compression End Cap",
                  "PP MTA / FTA"
            ]
      },
      {
            "id": "ball-valves",
            "num": "15",
            "name": "Ball Valves",
            "hindi": "बॉल वाल्व",
            "desc": "Smooth flow control ke liye PP/PVC ball valves — 20–110 mm full range, long life.",
            "features": [
                  "Smooth quarter-turn control",
                  "PP / PVC body options",
                  "Full flow bore design",
                  "20–110 mm range"
            ],
            "range": [
                  "PP Ball Valve",
                  "PVC Ball Valve",
                  "Single Union Valve",
                  "Double Union Valve"
            ],
            "specs": [
                  "20–110 mm",
                  "PN 10–16"
            ],
            "img": "https://compassionate-mclaren-9.preview.emergentagent.com/api/files/jamna-industries/uploads/f4d16ba2-18ae-4050-afef-fd749da9bfdb.jpg",
            "alt": "Industrial ball valves",
            "items": [
                  "PP Ball Valve",
                  "PVC Ball Valve",
                  "Single Union Ball Valve",
                  "Double Union Ball Valve"
            ]
      },
      {
            "id": "foot-valves",
            "num": "16",
            "name": "Foot Valves",
            "hindi": "फुट वाल्व",
            "desc": "Pump suction ke liye heavy-duty foot valves — backflow rokta hai, pump ko safe rakhta hai.",
            "features": [
                  "Backflow protection for pumps",
                  "Heavy-duty spring/flap action",
                  "Brass / PP options",
                  "Long service life"
            ],
            "range": [
                  "PP Foot Valve",
                  "Brass Foot Valve",
                  "Spring Type Valve"
            ],
            "specs": [
                  "25–100 mm",
                  "Suction rated"
            ],
            "img": "https://compassionate-mclaren-9.preview.emergentagent.com/api/files/jamna-industries/uploads/f4d16ba2-18ae-4050-afef-fd749da9bfdb.jpg",
            "alt": "Foot valve machinery",
            "items": [
                  "PP Foot Valve",
                  "Brass Foot Valve",
                  "Spring Foot Valve",
                  "Foot Valve Strainer"
            ]
      },
      {
            "id": "air-release-valves",
            "num": "17",
            "name": "Air Release Valves",
            "hindi": "एयर रिलीज़ वाल्व",
            "desc": "Pipeline se hawa nikaalne ke liye — pressure balance rakhta hai, line ko damage se bachata hai.",
            "features": [
                  "Automatic air release",
                  "Pipeline pressure balance",
                  "Anti-surge design",
                  "Easy top mounting"
            ],
            "range": [
                  "Single Acting",
                  "Double Acting",
                  "Kinetic Type"
            ],
            "specs": [
                  "25–80 mm",
                  "PN 10"
            ],
            "img": "https://compassionate-mclaren-9.preview.emergentagent.com/api/files/jamna-industries/uploads/f4d16ba2-18ae-4050-afef-fd749da9bfdb.jpg",
            "alt": "Air release valve",
            "items": [
                  "Air Release Valve — Single Acting",
                  "Air Release Valve — Double Acting",
                  "Kinetic Air Valve"
            ]
      },
      {
            "id": "service-saddles",
            "num": "18",
            "name": "Service Saddles & Clamps",
            "hindi": "सर्विस सैडल और क्लैंप",
            "desc": "Main line pe branch connection ke liye service saddles, saddle clamps aur GI clamps — strong grip.",
            "features": [
                  "Strong grip on HDPE/PVC mains",
                  "Leak-proof tapping",
                  "Galvanised bolts",
                  "All pipe sizes available"
            ],
            "range": [
                  "PP Service Saddle",
                  "Saddle Clamp",
                  "GI Clamp"
            ],
            "specs": [
                  "63–160 mm mains",
                  "1/2–2 inch outlet"
            ],
            "img": "https://compassionate-mclaren-9.preview.emergentagent.com/api/files/jamna-industries/uploads/f4d16ba2-18ae-4050-afef-fd749da9bfdb.jpg",
            "alt": "Service saddles and clamps",
            "items": [
                  "PP Service Saddle",
                  "Saddle Clamp",
                  "GI Clamp",
                  "Tapping Saddle"
            ]
      },
      {
            "id": "sprinkler-accessories",
            "num": "19",
            "name": "Sprinkler Accessories",
            "hindi": "स्प्रिंकलर एक्सेसरीज",
            "desc": "Riser pipes, nozzles, stands, keys aur spanners — sprinkler setup ke saare zaroori parts.",
            "features": [
                  "Complete sprinkler parts range",
                  "Quick-coupling compatible",
                  "Field-tough quality",
                  "Easy replacement"
            ],
            "range": [
                  "Riser Pipes",
                  "Nozzles",
                  "Stands",
                  "Keys & Spanners",
                  "Gaskets"
            ],
            "specs": [
                  "Standard fit",
                  "1/2–3/4 inch"
            ],
            "img": "https://compassionate-mclaren-9.preview.emergentagent.com/api/files/jamna-industries/uploads/f4d16ba2-18ae-4050-afef-fd749da9bfdb.jpg",
            "alt": "Sprinkler accessories in field",
            "items": [
                  "Sprinkler Riser Pipe",
                  "Sprinkler Nozzle Set",
                  "Sprinkler Stand",
                  "Sprinkler Key & Spanner",
                  "Coupling Gasket",
                  "End Plug"
            ]
      },
      {
            "id": "drip-accessories",
            "num": "20",
            "name": "Drip Accessories",
            "hindi": "ड्रिप एक्सेसरीज",
            "desc": "Start connector, take-off, grommet, end cap, hole punch aur lateral valves — drip line ka poora saaman.",
            "features": [
                  "Complete drip fittings range",
                  "Anti-leak design",
                  "UV-stabilised plastic",
                  "Universal 16 mm fit"
            ],
            "range": [
                  "Start Connector",
                  "Take-off",
                  "Grommet",
                  "End Cap",
                  "Hole Punch",
                  "Lateral Valve"
            ],
            "specs": [
                  "16 mm",
                  "Universal fit"
            ],
            "img": "https://compassionate-mclaren-9.preview.emergentagent.com/api/files/jamna-industries/uploads/f4d16ba2-18ae-4050-afef-fd749da9bfdb.jpg",
            "alt": "Drip irrigation accessories",
            "items": [
                  "Start Connector",
                  "Take-off",
                  "Grommet",
                  "Lateral End Cap",
                  "Hole Punch",
                  "Lateral Valve",
                  "Flush Valve",
                  "Joiner"
            ]
      }
],
  spotlight: {
    overline: "Featured Solution",
    headingA: "Jamna Drip + HDPE combo —",
    headingAccent: "kam paani, zyada upaj.",
    sub: "Complete drip kit with HDPE mains, screen filter aur venturi injector — ek hi setup mein 1 se 5 acre tak. PMKSY subsidy-ready designs ke saath.",
    image: "https://images.unsplash.com/photo-1758414089320-dac72d347fca?auto=format&fit=crop&w=1800&q=80",
    stats: [
      { value: "60%", label: "Tak Paani Ki Bachat" },
      { value: "40%", label: "Tak Zyada Upaj" },
    ],
    cta: "Get Combo Quote",
  },
  stats: [
    { value: "25+", label: "Years of Manufacturing Trust" },
    { value: "10,000+", label: "Farmers Empowered" },
    { value: "500+", label: "Dealers & Distributors" },
    { value: "ISO 9001", "label": "Certified Quality" },
  ],
  stories: [
    { name: "Ramesh Choudhary", place: "Sikar, Rajasthan", crop: "Groundnut — Mini Sprinkler", quote: "Mini sprinkler lagane ke baad paani lagbhag aadha lagta hai aur pedavdar 30% badh gayi. Jamna ki pipe quality pe poora bharosa hai." },
    { name: "Sukhdev Singh", place: "Jaipur, Rajasthan", crop: "Vegetables — Drip Kit", quote: "5 acre ka drip kit ek din mein fit ho gaya. Khad ka kharcha bhi kam, mehnat bhi kam — aur fasal pehle se behtar." },
    { name: "Mahesh Patel", place: "Kota, Rajasthan", crop: "Wheat — HDPE Pipes", quote: "Bore se khet tak HDPE line dalwai — leak kahin nahi, pressure poora. Teen season ho gaye, ek baar bhi repair nahi karani padi." },
  ],
  crops: [
    { icon: "wheat", name: "Gehun / Wheat", system: "Mini Sprinkler", saving: "35%" },
    { icon: "sprout", name: "Ganna / Sugarcane", system: "Drip System", saving: "60%" },
    { icon: "leaf", name: "Moongphali / Groundnut", system: "Mini Sprinkler", saving: "45%" },
    { icon: "carrot", name: "Sabziyan / Vegetables", system: "Drip Kit", saving: "55%" },
    { icon: "apple", name: "Bagicha / Orchards", system: "Micro Sprinkler", saving: "50%" },
    { icon: "flower", name: "Kapas / Cotton", system: "Drip System", saving: "50%" },
  ],
  updates: [
    { date: "15 Aug 2026", tag: "Exhibition", title: "Kisan Mela Jaipur mein Jamna ka stall — live mini sprinkler demo dekhein" },
    { date: "02 Jul 2026", tag: "New Launch", title: "110mm PN-16 HDPE coil range ab sprinkler mains ke liye available" },
    { date: "20 May 2026", tag: "Subsidy Desk", title: "PMKSY subsidy guidance desk ab Jaipur works par — documents ki madad bilkul free" },
  ],
  dealer: {
    overline: "Partner With Us",
    headingA: "Become a",
    headingAccent: "Jamna Dealer.",
    sub: "Rajasthan bhar mein Jamna ka dealer network expand ho raha hai. Best margins, fast stock supply aur poori technical support ke saath — apne area ke liye aaj hi apply karein.",
    cta: "Apply for Dealership",
  },
  certifications: [
    { code: "IS 4984", label: "HDPE Pipes Certified" },
    { code: "IS 4985", label: "PVC Pipes Certified" },
    { code: "IS 14151", label: "Sprinkler Systems Certified" },
    { code: "ISO 9001:2015", label: "Quality Management" },
    { code: "PMKSY", label: "Subsidy-Ready Designs" },
  ],
  contact: {
    phone: "+91 98290 57721",
    email: "surendragajraj@gmail.com",
    address: "F-132, Road No. 12, V.K.I. Area, Jaipur, Rajasthan",
    gstin: "08ABYPG2156Q1ZT",
    social: {
      facebook: "https://www.facebook.com/jamnaindustries",
      instagram: "https://www.instagram.com/jamnaindustries",
      twitter: "https://twitter.com/jamnaindustries",
      linkedin: "https://www.linkedin.com/company/jamnaindustries",
    },
  },
  team: [
    { name: "Surendra Gajraj", designation: "Founder & Proprietor", sales: "—", photo: "" },
  ],
  app: {
    name: "Jamna Connect",
    version: "1.0",
    desc: "Dealers aur kisan ke liye Jamna app — product catalogue, order status aur support ek hi jagah.",
    apkUrl: "",
  },
  fittings: [
    { id: "pvc-fittings", name: "PVC Fittings", hindi: "पीवीसी फिटिंग", desc: "Elbow, Tee, Coupler, Reducer, Bush, End Cap, MTA/FTA — full range 20–110 mm, leak-proof joints ke saath.", img: "https://images.unsplash.com/photo-1538474705339-e87de81450e8?auto=format&fit=crop&w=1200&q=80", alt: "PVC pipe fittings" },
    { id: "pp-compression-fittings", name: "PP Compression Fittings", hindi: "पीपी कम्प्रेशन फिटिंग", desc: "Coupler, Elbow, Tee, End Cap — tool-free fitting, HDPE pipes ke liye perfect grip aur leak-proof seal.", img: "https://images.unsplash.com/photo-1766651897083-62a5379b3d7d?auto=format&fit=crop&w=1200&q=80", alt: "PP compression fittings with pipes" },
    { id: "ball-valves", name: "Ball Valves", hindi: "बॉल वाल्व", desc: "Smooth flow control ke liye PP/PVC ball valves — 20–110 mm full range, long life.", img: "https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?auto=format&fit=crop&w=1200&q=80", alt: "Industrial ball valves" },
    { id: "foot-valves", name: "Foot Valves", hindi: "फुट वाल्व", desc: "Pump suction ke liye heavy-duty foot valves — backflow rokta hai, pump ko safe rakhta hai.", img: "https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?auto=format&fit=crop&w=1200&q=80&crop=entropy", alt: "Foot valve machinery" },
    { id: "air-release-valves", name: "Air Release Valves", hindi: "एयर रिलीज़ वाल्व", desc: "Pipeline se hawa nikaalne ke liye — pressure balance rakhta hai, line ko damage se bachata hai.", img: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&w=1200&q=80", alt: "Air release valve" },
    { id: "service-saddles", name: "Service Saddles & Clamps", hindi: "सर्विस सैडल और क्लैंप", desc: "Main line pe branch connection ke liye service saddles, saddle clamps aur GI clamps — strong grip.", img: "https://images.unsplash.com/photo-1538474705339-e87de81450e8?auto=format&fit=crop&w=1200&q=80&crop=entropy", alt: "Service saddles and clamps" },
    { id: "sprinkler-accessories", name: "Sprinkler Accessories", hindi: "स्प्रिंकलर एक्सेसरीज", desc: "Riser pipes, nozzles, stands, keys aur spanners — sprinkler setup ke saare zaroori parts.", img: "https://images.unsplash.com/photo-1738598665698-7fd7af4b5e0c?auto=format&fit=crop&w=1200&q=80", alt: "Sprinkler accessories in field" },
    { id: "drip-accessories", name: "Drip Accessories", hindi: "ड्रिप एक्सेसरीज", desc: "Start connector, take-off, grommet, end cap, hole punch aur lateral valves — drip line ka poora saaman.", img: "https://images.unsplash.com/photo-1748432171507-c1d62fe2e859?auto=format&fit=crop&w=1200&q=80", alt: "Drip irrigation accessories" },
  ],
};
